<template>
  <div class="flex_vertial">
    <div style="flex:1;"></div>
    <img class="robot" :src="faceUrl">
    <div class="title1" v-if="name">{{ name }}</div>
    <div class="title2">{{ num }}</div>
    <div class="sub_title">当前帮你接听的号码</div>
    <div style="flex:4;"></div>
    <a v-if="num" class="open_button" @click="changeNum">更换号码</a>
    <div class="help">每一个帐号仅能享用1个号码的代接服务</div>

  </div>
</template>

<script>
import app from '@/AppData'
import defaultFaceUrl from '@/assets/called.png'

const TAG = 'bindChangeNumNotify'
export default {
  name: 'bindGuidePage',
  data () {
    return {
      num: app.getData().userSetting.phoneNum,
      faceUrl: defaultFaceUrl,
      name: app.getData().accountName
    }
  },
  methods: {
    calltest () {
      this.$router.replace({
        path: '/bind_dail_try_verify'
      })
    },
    changeNum () {
      this.$router.push({
        name: 'bind_phone',
        params: {
          from: 'changePhone'
        }
      })
    }
  },
  mounted () {
    if (app.getData().accountFaceUrl != null) {
      this.faceUrl = app.getData().accountFaceUrl
    } else {
      this.faceUrl = defaultFaceUrl
    }
    console.log(TAG, 'accountFaceUrl', app.getData().accountFaceUrl)
  }
}
</script>

<style scoped lang="less" src="@/styles/common.less"/>
<style scoped>

.title1 {
  font-family: PingFangSC-Regular;
  font-size: 1.15rem;
  color: #000000;
  text-align: center;
  margin-bottom: 1.2rem;
}

.title2 {
  font-family: PingFangSC-Semibold;
  font-size: 2.2rem;
  color: #000000;
  text-align: center;
}

.sub_title {
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  color: #000000;
  text-align: center;
  margin-top: 0.8rem;
}

.robot {
  width: 4.5rem;
  height: 4.5rem;
  margin-bottom: 1rem;
}

.help_layout {
  display: flex;
  margin-bottom: 1rem;
  align-content: center;
  align-items: center;
}

.help {
  height: 1.25rem;
  font-family: PingFangSC-Regular;
  font-size: 0.9rem;
  line-height: 1.25rem;
  color: #999999;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 2rem;
}

.help_arch {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 0.8rem;
  background: #AAAAAA;
  margin-left: 0.5rem;

  font-size: 0.8rem;
  line-height: 0.8rem;
  color: white;
  text-align: center;
}

.jiantou {
  margin-top: 0.2rem;
  margin-left: 0.1rem;
  width: 0.3rem;
  height: 0.3rem;
  border-top: 0.1rem solid white;
  border-right: 0.1rem solid white;
  transform: rotate(45deg);
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/bind/BindChangeNumNotify.vue